import styled from 'styled-components'
import { blue, white } from '@/theme/colors'
import { radii, media } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'
import { Button } from '@components/Button'

export const Band = styled.section`
	margin-top: 48px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
	flex-wrap: wrap;
	padding: 30px 34px;
	background: ${blue};
	border-radius: ${radii.band};
	color: ${white};

	/* Phone: a centered, stacked CTA card rather than the wide desktop band. */
	${media.phone} {
		margin-top: 24px;
		flex-direction: column;
		align-items: center;
		text-align: center;
		gap: 16px;
		padding: 22px 20px;
	}
`

/* Explicit white: the GlobalStyle h2/p element rules paint dark otherwise. */
export const BandTitle = styled.h2`
	${text.display}
	font-size: ${fontSizes.headingLg};
	color: ${white};
	margin: 0;
`

export const BandSub = styled.p`
	${text.bodySm}
	color: ${white};
	opacity: 0.85;
	margin: 6px 0 0;
	max-width: 520px;
	text-wrap: pretty;
`

export const BandActions = styled.div`
	display: flex;
	gap: 10px;
	flex-shrink: 0;
	flex-wrap: wrap;

	/* Phone: full-width stacked buttons under the copy. */
	${media.phone} {
		width: 100%;
		flex-direction: column;
		gap: 10px;
	}
`

/** Ghost on the cool band: white text with a translucent white hairline. Rendered as an anchor at the call site. */
export const OutlineButton = styled(Button).attrs({ variant: 'ghost' as const })`
	color: ${white};
	border-color: ${white}80;
	font-size: ${fontSizes.base};

	&:hover:not(:disabled) {
		background: ${white}1a;
	}

	${media.phone} {
		width: 100%;
		min-height: 44px;
	}
`

export const OrangeButton = styled(Button)`
	font-size: ${fontSizes.base};

	${media.phone} {
		width: 100%;
		min-height: 44px;
	}
`
